import { useRef } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { KTCard } from "../../../_metronic/helpers";
import MuiTable from "../../../components/table/MuiTable";
import { AnnouncementData } from "../hooks/useAdminAnnouncements";

interface TableOptions {
  skip: number;
  take: number;
  totalRowCount: number;
  SearchText: string;
}

interface AnnouncementsTableProps {
  columns: GridColDef[];
  tableOptions: TableOptions;
  tableData: AnnouncementData[];
  loading?: boolean;
  handleAddClick: () => void;
  handlePagination: (values: { page: number; pageSize: number }) => void;
  handleLastPage: () => void;
  handleFirstPage: () => void;
}

const AnnouncementsTable: React.FC<AnnouncementsTableProps> = ({
  columns,
  tableOptions,
  tableData,
  loading = false,
  handleAddClick,
  handlePagination,
  handleLastPage,
  handleFirstPage,
}) => {
  const tableRef = useRef(null);

  return (
    <KTCard>
      <h3 style={{ position: "absolute", top: "5px" }}>Announcements</h3>
      <MuiTable
        addLabel="Create Announcement"
        handleAddClick={handleAddClick}
        columns={columns}
        tableRef={tableRef}
        isRowClickable={false}
        handlePagination={handlePagination}
        handleLastPage={handleLastPage}
        handleFirstPage={handleFirstPage}
        tableOptions={tableOptions}
        isAddEnable={true}
        data={tableData}
        loading={loading}
      />
    </KTCard>
  );
};

export default AnnouncementsTable;